import { useState } from "react"

export const useColor = () => {
  const [companyTheme, setCompanyTheme] = useState({
    first: "black",
    second: "white",
  })

  return { companyTheme }
}
